import React, { useState } from "react";
import "./Common_Login_Vendor_Details.css";
import Common_Call_Button from "../common-send-button/common-call-button/Common_Call_Button";
import Subscription_Needed_Lottie_Modal from "../subscription-needed-lottie-modal/Subscription_Needed_Lottie_Modal";

const Common_Login_Vendor_Details = ({ data, onCallClick }) => {
  const [showModal, setShowModal] = useState(false);

  if (!data) return null;
  const handleCallButtonClick = (e) => {
    setShowModal(true);
    if (onCallClick) {
      onCallClick(e);
    }
  };

  return (
    <div className="vendor-login-card-wrapper">
      <div className="vendor-login-card-wrapper__inner">

        <div className="vendor-login-card-wrapper__image-container">
          <img src={data.img} alt={data.name} />
        </div>

        <div className="vendor-login-card-wrapper__content">
          <h3 className="vendor-login-card-wrapper__title">{data.name}</h3>

          <div className="vendor-login-card-wrapper__details-grid">
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">Material :-</span>
              <span className="vendor-login-card-wrapper__value">{data.material}</span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">Timeline :-</span>
              <span className="vendor-login-card-wrapper__value">{data.timeline}</span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">State :-</span>
              <span className="vendor-login-card-wrapper__value">{data.state}</span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">District :-</span>
              <span className="vendor-login-card-wrapper__value">{data.district}</span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">Taluka :-</span>
              <span className="vendor-login-card-wrapper__value">{data.taluka}</span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">Area :-</span>
              <span className="vendor-login-card-wrapper__value">{data.area}</span>
            </div>
          </div>

          <div className="vendor-login-card-wrapper__footer">
            <Common_Call_Button onClick2={handleCallButtonClick} />
          </div>
        </div>
      </div>
      <Subscription_Needed_Lottie_Modal
        showSubscription={showModal}
        handleSubscriptionClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default Common_Login_Vendor_Details;